<template>
  <div class="TextAnime1">
    <div>
    <span v-for="(t, index) in text" :key="index" v-text="t" class="item delay-anime"/>
    </div>
    <div>
      <span v-for="(t, index) in text2" :key="index" v-text="t" class="item delay-anime"/>
    </div>
  </div>


</template>

<script>
export default {
  data() {
    return {
      text: 'Technology + Idea =',
      text2: 'Happy!'
    }
  }
}
</script>

<style lang="stylus" scoped>
@keyframes text-in {
  0% {
    transform: translate(0, -20px);
    opacity: 0;
  }
}

.item {
  display: inline-block;
  min-width: 0.3em;
  font-size: 2rem;
  animation: text-in 1s cubic-bezier(0.22, 0.15, 0.25, 1.43) 0s backwards;
  font-size: 52px;
  color: #fff;
  font-weight: bold;
}

@media screen and (max-width:640px) {
  .item {
    font-size: 32px;
  }
}

@media screen and (max-width:420px) {
  .item {
    font-size: 26px;
  }
}

for co in 0 .. 27 {
  .delay-anime:nth-child({co + 1}) {
    animation-delay: co * 100ms + 200ms;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/animation/TextAnime1.vue